import TimeAndAgo from '@/components/TimeAndAgo.vue';

import { QaQuestionContentMixin } from '@/scripts/QA/Question/mixins/QaQuestionContentMixin';

export default {
  name: 'QaQuestionContentTeacherAnswer',

  mixins: [QaQuestionContentMixin],

  components: {
    'time-and-ago': TimeAndAgo,
  },

  props: {
    p_objQa: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ///
    c_objQaContent() {
      return this.p_objQa.qaAnswerContent;
    },
  },
};
